import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=0dda540e&scoped=true"
import script from "./Post.vue?vue&type=script&lang=ts"
export * from "./Post.vue?vue&type=script&lang=ts"
import style0 from "./Post.vue?vue&type=style&index=0&id=0dda540e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda540e",
  null
  
)

export default component.exports